export default "<app-criteria criteria=\"sector\">\r\n"